import type { AxiosInstance } from "axios";

import type {
  CreateIncidentReportRequest,
  OrganisationId,
  SupersetDashboardExportRequest,
} from "@thalamos/vision-common";

export const config = {
  report: {
    createIncidentReport: (
      id: OrganisationId,
      createIncidentReportRequest: CreateIncidentReportRequest,
    ) => ({
      url: `/api/report/incidents/${id}`,
      method: "post",
      data: createIncidentReportRequest,
    }),
    getSupersetDashboard: (organisationId: OrganisationId) => ({
      url: `/api/report/superset-dashboard/${organisationId}`,
      method: "get",
    }),
    exportSupersetDashboard: (
      organisationId: OrganisationId,
      request: SupersetDashboardExportRequest,
    ) => ({
      url: `/api/report/superset-dashboard/${organisationId}/export`,
      method: "post",
      data: request,
    }),
    getPowerBiDashboard: (organisationId: OrganisationId) => ({
      url: `/api/report/power-bi-dashboard/${organisationId}`,
      method: "get",
    }),
  },
};

export const api = (apiAxios: AxiosInstance) => {
  return {
    report: {
      createIncidentReport: (
        id: OrganisationId,
        createIncidentReportRequest: CreateIncidentReportRequest,
      ) =>
        apiAxios.request(
          config.report.createIncidentReport(id, createIncidentReportRequest),
        ),
      getSupersetDashboard: (organisationId: OrganisationId) =>
        apiAxios.request(config.report.getSupersetDashboard(organisationId)),
      exportSupersetDashboard: (
        organisationId: OrganisationId,
        request: SupersetDashboardExportRequest,
      ) =>
        apiAxios.request(
          config.report.exportSupersetDashboard(organisationId, request),
        ),
      getPowerBiDashboard: (organisationId: OrganisationId) =>
        apiAxios.request(config.report.getPowerBiDashboard(organisationId)),
    },
  };
};
